import React, { FC, ReactNode } from 'react';
import classnames from 'classnames/bind';
import styles from './styles.module.css';

const cx = classnames.bind(styles);

type RadioPropsType = {
  name: string;
  value: number | string;
  label: string | ReactNode;
  checked: boolean;
  className?: string;
  indicatorClassName?: string;
  disabled?: boolean;
  onChecked: () => void;
  dataTestIdPrefix?: string;
};

export const Radio: FC<RadioPropsType> = ({
  label,
  onChecked,
  name,
  value,
  checked,
  className,
  indicatorClassName,
  disabled,
  dataTestIdPrefix,
}) => {
  const id = dataTestIdPrefix
    ? `${dataTestIdPrefix}_${name}_${value}`
    : `${name}_${value}`;
  const labelTestId = dataTestIdPrefix
    ? `${dataTestIdPrefix}_${name}-${value}`
    : `${name}-${value}`;
  return (
    <div
      className={cx('container', { disabled }, className)}
      onClick={() => !disabled && !checked && onChecked()}
    >
      <input
        data-testid={id}
        id={id}
        name={name}
        className={styles.input}
        type="radio"
        checked={checked}
        disabled={disabled}
        readOnly
      />
      <div className={cx('indicator', { checked }, indicatorClassName)} />
      <label
        htmlFor={id}
        data-testid={`checkbox-${labelTestId}-label`}
        className={styles.label}
      >
        {label}
      </label>
    </div>
  );
};
